import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/docs/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import './setup-and-access.scss';
import { Paragraph, SmallText, NumberedList, LeadParagraph, ListItem, Link, StrongText, Heading4, UnorderedList } from '@entur/typography';
import IconCircle from '~/components/IconCircle/IconCircle';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const OrganizationIcon = makeShortcode("OrganizationIcon");
const ClosedLockIcon = makeShortcode("ClosedLockIcon");
const RightArrowIcon = makeShortcode("RightArrowIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "setup-and-access"
    }}>{`Setup and Access`}</h1>
    <LeadParagraph mdxType="LeadParagraph">
    Entur's services are divided in to two specific areas:
    </LeadParagraph>
    <div className="setup__areas">
    <div className="setup__icon setup__icon--open">
        <IconCircle icon={<OrganizationIcon mdxType="OrganizationIcon" />} mdxType="IconCircle" />
    </div>
    <div className="setup__text">
        <Heading4 mdxType="Heading4">Open Services</Heading4>
        <Paragraph mdxType="Paragraph">
            A National hub for public transport information open to everyone
        </Paragraph>
    </div>
    <div className="setup__icon setup__icon--partner">
        <IconCircle icon={<ClosedLockIcon mdxType="ClosedLockIcon" />} mdxType="IconCircle" />
    </div>
    <div className="setup__text">
        <Heading4 mdxType="Heading4">Partner Services</Heading4>
        <Paragraph mdxType="Paragraph">A sales provider for rail operators/partners</Paragraph>
    </div>
    </div>
    <h2 {...{
      "id": "licenses"
    }}>{`Licenses`}</h2>
    <p>{`Data provided by Entur AS from API or published data files can be used under the `}<a parentName="p" {...{
        "href": "https://data.norge.no/nlod/en"
      }}>{`Norwegian Licence for Open Government Data (NLOD)`}</a>{`.
You are allowed to copy and make available, change and/or merge with other datasets, and to use them for commercial purposes.`}</p>
    <p><a parentName="p" {...{
        "href": "/pages-intro-authentication"
      }}>{`Read more about authentication`}</a>{` `}<RightArrowIcon mdxType="RightArrowIcon" /></p>
    <div className="setup__list-license">
    Note, in particular, the following:
    <UnorderedList mdxType="UnorderedList">
        <ListItem mdxType="ListItem">
            Entur should be credited as the source with the text: Data made
            available by Entur + (logo)
        </ListItem>
        <ListItem mdxType="ListItem">
            Entur assumes no liability for consequences of errors in the data or
            API-systems.
        </ListItem>
        <ListItem mdxType="ListItem">
            The data should not be presented in a distorted or misrepresentative
            way
        </ListItem>
        <ListItem mdxType="ListItem">
            Open source projects can be used under{' '}
            <Link href="https://opensource.org/licenses/EUPL-1.2" mdxType="Link">
                European Union Public Licence v. 1.2 (EUPL-1.2)
            </Link>
            .
        </ListItem>
    </UnorderedList>
    </div>
    <h2 {...{
      "id": "access-partner-services"
    }}>{`Access Partner Services`}</h2>
    <div className="setup__list-wrapper">
    <NumberedList mdxType="NumberedList">
        <ListItem mdxType="ListItem">
            <Paragraph mdxType="Paragraph">
                As a Partner the first thing you must do is to set up an
                agreement between you and Entur.
            </Paragraph>
            <Paragraph mdxType="Paragraph">
                In addition, you must set up an agreement between you and the
                third party that you will sell tickets for. This agreement needs
                to include a clear definition of which products you may sell and
                which third party this agreement covers.
            </Paragraph>
        </ListItem>
        <ListItem mdxType="ListItem">
            Entur creates an <StrongText mdxType="StrongText">OrganisationID</StrongText>.
        </ListItem>
        <ListItem mdxType="ListItem">
            Entur creates a Slack channel for communication.
            <br />
            <SmallText mdxType="SmallText">Entur wants to avoid bug reports by email.</SmallText>
        </ListItem>
        <ListItem mdxType="ListItem">
            You will receive a Client ID and Client Secrets as «shared notes» in
            Lastpass.
            <br />
            <Link href="/pages-intro-authentication" mdxType="Link">
                See how Client ID and Client Secrets are used to get a TOKEN.
            </Link>
            <br />
            <SmallText mdxType="SmallText">
                NOTE: The examples explain access to PROD. There is a list of
                the environments on the same page. By default, you are given
                access to the STAGING Environment.
            </SmallText>
            <Paragraph mdxType="Paragraph">
                Partners should check that the services are working and that
                they can be accessed. No products will be sold until the final
                points have been completed.
            </Paragraph>
            <Paragraph mdxType="Paragraph">
                After receiving Client ID and Client Secrets, the Partner is
                responsible for storing these in their organisation.
            </Paragraph>
            <Paragraph mdxType="Paragraph">
                NOTE! A self-service option for creating Client ID and Client
                Secret is possible through the{' '}
                <Link href="https://entur-partner.entur.org/" mdxType="Link">
                    Entur Partner Portal
                </Link>
                , as long as you have a valid user with the role "Klientadministrator".
                <br />
                <br />
                For other environments visit the following links.
                <br />- <Link href="https://entur-partner.dev.entur.org/" mdxType="Link">
                    DEVELOPMENT Entur Partner Portal
                </Link>
                <br />-{' '}
                <Link href="https://entur-partner.staging.entur.org/" mdxType="Link">
                    STAGING Entur Partner Portal
                </Link>
            </Paragraph>
        </ListItem>
        <ListItem mdxType="ListItem">
            Entur will present which products you may sell per your agreement.
        </ListItem>
        <ListItem mdxType="ListItem">
            Entur will inform you when the products are ready for use.
        </ListItem>
        <ListItem mdxType="ListItem">
            Test, technical help, improvements, settlement and certification is
            the final step before the same procedure is done to get access to
            the production environment.
        </ListItem>
    </NumberedList>
    </div>
    <h2 {...{
      "id": "agreements-for-sale-of-tickets"
    }}>{`Agreements for Sale of Tickets`}</h2>
    <Paragraph mdxType="Paragraph">
    Entur AS allows third party ticket sales, provided an agreement between
    Entur AS, the provider of the ticket, and the third party have a signed
    agreement for that purpose. Contact Entur AS to initiate the agreement
    process.
    </Paragraph>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      